'use client';

import type { EventMarket, EventResponse } from '@/types';
import { CustomBinaryCard } from './variants/CustomBinaryCard';
import { MultiOutcomeCard } from './variants/MultiOutcomeCard';
import { ResolvedMarketCard } from './variants/ResolvedMarketCard';
import { SimpleBinaryCard } from './variants/SimpleBinaryCard';
import { SportsCard } from './variants/SportsMarketCard';

import { UMA_RESOLUTION_STATUS } from '@/constants';

interface MarketCardVariantsProps {
  eventType: string;
  event: EventResponse;
  market: EventMarket;
  outcomes: string[];
  onTradeClick?: (marketId: string, outcomeId: string, isBuy: boolean) => void;
  sortedMarkets: EventMarket[];
  isFullWidthActions?: boolean;
}

export function MarketCardVariants({
  eventType,
  event,
  market,
  outcomes,
  onTradeClick,
  sortedMarkets,
  isFullWidthActions: _isFullWidthActions,
}: MarketCardVariantsProps) {
  if (market.umaResolutionStatus === UMA_RESOLUTION_STATUS.RESOLVED) {
    return (
      <ResolvedMarketCard
        event={event}
        market={market}
        outcomes={outcomes}
        onTradeClick={onTradeClick}
      />
    );
  }

  if (eventType === 'CUSTOM_BINARY') {
    return (
      <CustomBinaryCard
        event={event}
        market={market}
        outcomes={outcomes}
        onTradeClick={onTradeClick}
      />
    );
  }
  if (eventType === 'MULTI_OUTCOME' || eventType === 'MULTI_QUESTION') {
    if (sortedMarkets.length === 1) {
      return (
        <SimpleBinaryCard
          event={event}
          market={market}
          outcomes={outcomes}
          onTradeClick={onTradeClick}
        />
      );
    }
    return (
      <MultiOutcomeCard
        event={event}
        market={market}
        outcomes={outcomes}
        onTradeClick={onTradeClick}
      />
    );
  }
  if (eventType === 'SPORTS_CARD') {
    return (
      <SportsCard event={event} market={market} outcomes={outcomes} onTradeClick={onTradeClick} />
    );
  }
  // if (eventType === 'MULTI_QUESTION') {
  //   return (
  //     <MultiQuestionCard
  //       event={event}
  //       market={market}
  //       outcomes={outcomes}
  //       onTradeClick={onTradeClick}
  //     />
  //   );
  // }
  return (
    <SimpleBinaryCard
      event={event}
      market={market}
      outcomes={outcomes}
      onTradeClick={onTradeClick}
    />
  );
}
